import type { Component } from 'vue';

const load = () => import('./ui/index.vue');

export const ConsultationModal: Component = defineAsyncComponent(() =>
  load().then((m: { default: Component }) => m.default),
);

export const prefetchConsultationModal = (): void => {
  load().catch(() => null);
};
